import { thousands } from '@/common/utils';
/* *******************
 * 以下是该业务模块用到的些比较强业务的工具
 ******************* */
// 保留两位数字
export function lintShowNum(num = 0) {
  if (computedIsEmpty(num)) {
    return false;
  }
  num = Number(num);
  if (!num || num < 10000) {
    return thousands(num);
  } else if (num >= 10000) {
    const resNum = (num / 10000).toString();
    const resIndex = resNum.indexOf('.');
    const showNum =
      resIndex > 0
        ? resNum.substring(resIndex + 1, resIndex + 3) !== '00'
          ? resNum.substring(0, resIndex + 3)
          : resNum.substring(0, resIndex)
        : resNum;

    return <>{thousands(showNum)}万</>;
  }
}

// 计算进度是否未空
export function computedIsEmpty(value) {
  if (value === '' || value == undefined || value === null) {
    return true;
  } else {
    return false;
  }
}
/* *******************
 * 以下是该业务模块用到一些枚举
 ******************* */
// 类型
export const ASSIGNTYPEENUM = {
  1: {
    key: 'ASSIGN_DEPT',
    name: '规则圈选',
  },
};

// 默认分页器参数
export const initPaginations = {
  defaultCurrent: 1,
  current: 1,
  pageSize: 5,
  total: 0,
};
